module.exports = __webpack_public_path__ + "img/default_img.c478b9ff.png";